export const patternSupportLinks = [
    {
        patternName: "Fake scarcity",
        patternUrl: "https://www.deceptive.design/types/fake-scarcity"
    },
    {
        patternName: "Fake social proof",
        patternUrl: "https://www.deceptive.design/types/fake-social-proof"
    },
    {
        patternName: "Fake urgency",
        patternUrl: "https://www.deceptive.design/types/fake-urgency"
    },
    {
        patternName: "Forced action",
        patternUrl: "https://deceptive.design/types/forced-action"
    },
    {
        patternName: "Obstruction",
        patternUrl: "https://www.deceptive.design/types/obstruction"
    },
    {
        patternName: "Nagging",
        patternUrl: "https://www.deceptive.design/types/nagging"
    },
    {
        patternName: "Confirmshaming",
        patternUrl: "https://www.deceptive.design/types/confirmshaming"
    },
    {
        patternName: "Disguised ads",
        patternUrl: "https://www.deceptive.design/types/disguised-ads"
    },
    {
        patternName: "Preselection",
        patternUrl: "https://www.deceptive.design/types/preselection"
    },
]